import React, { useState, useRef  } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import { BeatLoader } from 'react-spinners';
import "./FormularioWeb.css"

const FormularioWeb = () => {
  const [formData, setFormData] = useState({
    nombreCompleto: '',    
    ruc: '',
    telefono: '',
    correo: '',    
    mensaje: '',
    productoInteres: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const result = await emailjs.sendForm(
        process.env.REACT_APP_SERVICE_ID, // Reemplaza con tu Service ID
        process.env.REACT_APP_TEMPLATE_ID, // Reemplaza con tu Template ID
        formRef.current,
        process.env.REACT_APP_USER_ID // REACT_APP_Reemplaza con tu User ID
      );
      if (result.status === 200) {
        Swal.fire({
          title: "Sus datos fueron enviados. Un ejecutivo se pondrá en contacto con usted prontamente.",
          icon: "success",
          draggable: true
        });
        setFormData({ // Limpiar formulario
          nombreCompleto: "",
          empresa: "",
          rut: "",
          telefono: "",
          correo: "",
          region: "",
          mensaje: "",
          productoInteres: "",
        });
        formRef.current.reset();
       
      }
    } catch (error) {
      console.error("Error al enviar el correo:", error);
      Swal.fire({
        icon: "error",
        title: "Algo falló...",
        text: "Datos no guardados, inténtelo más tarde, por favor.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
     <div className="container">
      
      <form ref={formRef} onSubmit={handleSubmit}>
        <h3>Contáctanos</h3>
        <div>
          <label>Nombre Completo</label>
          <input type="text" name="nombreCompleto" value={formData.nombreCompleto} onChange={handleChange} />
        </div>
        <div>
          <label>RUC</label>
          <input type="text" name="ruc" value={formData.ruc} onChange={handleChange} />
        </div>
        <div>
          <label>Teléfono <span style={{ color: 'red' }}>*</span></label>
          <input type="text" name="telefono" value={formData.telefono} onChange={handleChange}  />
        </div>        
        <div>
          <label>Correo Electrónico</label>
          <input type="email" name="correo" value={formData.correo} onChange={handleChange} required />
        </div>
        
        <div>
          <label>Mensaje</label>
          <textarea name="mensaje" value={formData.mensaje} onChange={handleChange}></textarea>
        </div>
        <div>
          <label>Seleccione Producto de Interés</label>
          <select name="productoInteres" value={formData.productoInteres} onChange={handleChange}>

            <option value="">Seleccione un producto</option>
            <option value="Factoring">Factoring</option>           
            <option value="Factoring Internacional">Factoring Internacional</option>
            <option value="Otros">Otros</option>
          </select>
        </div>
        <div className="div-button">
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? <BeatLoader size={14} color="#fff" /> : 'Enviar'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default FormularioWeb;
